/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileDiscLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileDiscLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 38c0 11.608 6.392 18 18 18s18-6.392 18-18-6.392-18-18-18-18 6.392-18 18Zm17.25-12C29.995 26 26 29.995 26 37.25h3c0-5.552 2.698-8.25 8.25-8.25v-3Zm9.673 14.198C46.473 44.766 43.793 47 38.75 47v3c6.755 0 10.68-3.468 11.19-9.802h-3.017ZM38 42.5c-3.028 0-4.5-1.472-4.5-4.5s1.472-4.5 4.5-4.5 4.5 1.472 4.5 4.5-1.472 4.5-4.5 4.5Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M55.996 38.5C55.814 27.209 49.44 21 38 21c-11.44 0-17.814 6.209-17.996 17.5A30.667 30.667 0 0 1 20 38c0-11.608 6.392-18 18-18s18 6.392 18 18c0 .168-.001.334-.004.5Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M26.026 37.25c-.017.326-.026.66-.026 1h3c0-5.551 2.698-8.25 8.25-8.25v-1C31.698 29 29 31.698 29 37.25h-2.974ZM38.75 50v1c6.755 0 10.68-3.468 11.19-9.802h-.113C48.998 46.896 45.141 50 38.75 50Zm-5.236-11.5c.158 2.69 1.63 4 4.486 4s4.328-1.31 4.486-4c.01.162.014.328.014.5 0 3.028-1.472 4.5-4.5 4.5s-4.5-1.472-4.5-4.5c0-.172.005-.338.014-.5Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileDiscLarge
};
